import { useTranslation } from 'react-i18next';
import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';
import { Card } from '@fpsm/cxy-components/Card';
import { Spinner } from '@fpsm/cxy-components/Spinner';

import { type BettingInsightsResult, type EsIndex } from '~/configuration/types';

import styles from './styles/BettingInsights.module.scss';

export function BettingInsightsLoadingState<TIndex extends EsIndex, TResult extends BettingInsightsResult<TIndex>>() {
  const { items } = useInfiniteHits<TResult>();
  const { status } = useInstantSearch();
  const { t } = useTranslation();
  const hasResults = Boolean(items.length);
  const isLoadingResults = status !== 'idle';
  const shouldShowLoadingState = !hasResults && isLoadingResults;

  if (!shouldShowLoadingState) {
    return null;
  }

  return (
    <Card className={styles.loadingState} height="361px" padding="l" shouldCenter>
      <Spinner />
      <p>{t('CX_PLUS_LOADING')}</p>
    </Card>
  );
}
